"use client";

import { useEffect } from "react";

type AdUnitProps = {
  slot: string;
  format?: "auto" | "rectangle" | "horizontal" | "vertical";
  responsive?: boolean;
  className?: string;
  style?: React.CSSProperties;
};

declare global {
  // biome-ignore lint: Required for global type augmentation
  interface Window {
    adsbygoogle?: unknown[];
  }
}

export function AdUnit({
  slot,
  format = "auto",
  responsive = true,
  className,
  style,
}: AdUnitProps) {
  useEffect(() => {
    try {
      if (!window.adsbygoogle) {
        window.adsbygoogle = [];
      }
      window.adsbygoogle.push({});
    } catch {
      // Silently fail in development or if ad blocker is active
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const adClient = process.env.NEXT_PUBLIC_ADSENSE_PUBLISHER_ID;

  if (!adClient) {
    if (process.env.NODE_ENV === "development") {
      let minHeight = "250px";
      if (format === "horizontal") {
        minHeight = "90px";
      } else if (format === "vertical") {
        minHeight = "600px";
      }
      return (
        <div
          className={className}
          style={{
            minHeight,
            border: "2px dashed #ccc",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            ...style,
          }}
        >
          <span className="text-muted-foreground text-sm">
            Ad Unit: {slot} ({format})
          </span>
        </div>
      );
    }
    return null;
  }

  return (
    <div className={className} style={style}>
      <ins
        className="adsbygoogle"
        data-ad-client={adClient}
        data-ad-format={format}
        data-ad-slot={slot}
        data-full-width-responsive={responsive ? "true" : undefined}
        style={{ display: "block" }}
      />
    </div>
  );
}
